import { useContext } from "react";
import clsx from "clsx";

import { useGetBusinessInvoices } from "src/hooks/useGetBusinessInvoices";
import { useGetBusinessSubscriptions } from "src/hooks/useGetBusinessSubscriptions";
import { useBusinessBillingPageToken } from "src/hooks/useBillingPageToken";
import { useGetBusinessBillingInformation } from "src/hooks/useGetBusinessBillingInfo";
import { useBusinessBillingPageUrl } from "src/hooks/useBillingPageUrl";
import { useBusinessChildren } from "src/hooks/useBusinessChildren";

import { BusinessContext } from "src/components/Business/Base";
import { Invoices } from "./Invoices";
import { Subscriptions } from "./Subscriptions";
import { Billing } from "./Billing";

import styles from "./BillingDetails.module.css";

export const BusinessBillingDetails = () => {
  const { businessId, business } = useContext(BusinessContext);
  const { invoices, loading } = useGetBusinessInvoices(businessId);
  const { businessSubscriptions } = useGetBusinessSubscriptions(businessId, true);
  const { businessChildren } = useBusinessChildren(businessId);
  const { token } = useBusinessBillingPageToken(businessId);
  const { billingInfo } = useGetBusinessBillingInformation(businessId);
  const { billingInfoUrl } = useBusinessBillingPageUrl(businessId);

  return (
    <section>
      <div className={styles.pageDescription}>
        <h2 className={clsx("lds-h2-caps", styles.welcome)}>Billing details</h2>
        <p>
          Manage your Lens Business ID <strong>{`(${business?.handle || "-"})`}</strong> billing, subscriptions and
          payment methods here.
        </p>
      </div>
      <section className={styles.tabContent}>
        <h3 className="lds-h3">Payment method</h3>
        <p>Manage payment method for your Lens Subscriptions.</p>
        <Billing billingInfo={billingInfo} billingInfoUrl={billingInfoUrl} />
      </section>
      <section className={styles.tabContent}>
        <h3 className="lds-h3">Subscriptions</h3>
        <p>Manage your Lens subscriptions.</p>
        <Subscriptions
          businessChildren={businessChildren}
          subscriptions={businessSubscriptions}
          billingPageToken={token}
          loading={loading}
        />
      </section>
      <section className={styles.tabContent}>
        <h3 className="lds-h3">Billing history</h3>
        <p>Review you billing history and manage your invoices.</p>
        <Invoices businessChildren={businessChildren} billingPageToken={token} invoices={invoices} loading={loading} />
      </section>
    </section>
  );
};
